import React, { useState, useEffect } from 'react';
import { getDecimal } from "../global/utils";
import { useStyles } from "../styles/styles";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const LineItems = (props) => {
    const unpaidBalances = props.unpaidBalances;
    const classes = useStyles;
    const [unpaidTotal, setUnpaidTotal] = useState(null);

    useEffect(() => {
        if (!unpaidTotal && unpaidBalances && unpaidBalances.length > 0) {
            let total = 0;
            unpaidBalances.forEach(b => total += b.unpaidAmount);
            setUnpaidTotal(getDecimal(total));
        }
    }, [unpaidBalances, unpaidTotal])

    return (
        <>
            <Typography variant='subtitle1' sx={{...classes.title, margin: '1rem 1rem .5rem 1rem'}}>
                Unpaid Balances
            </Typography>
            <List sx={{...classes.list, maxHeight: '100%', margin: '0 1rem'}} >
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Grid
                                container
                                spacing={0}
                                alignItems="top"
                                style={{width: '100%'}}
                            >
                                <Grid item xs={8}>
                                    Case & Citation Numbers
                                </Grid>
                                <Grid item xs={4}>
                                    Unpaid Amount
                                </Grid>
                                <Grid item xs={8}>
                                    Description
                                </Grid>
                                <Grid item xs={4}>
                                    Violation Date
                                </Grid>
                            </Grid>
                        }
                        primaryTypographyProps={{
                            variant: 'subtitle2'
                        }}
                    />
                </ListItem>
                {unpaidBalances && unpaidBalances.length > 0 && unpaidBalances.map((bal) => {
                    return (
                        <>
                            <ListItem alignItems='flex-start' sx={{...classes.listPadding, borderBottom: '1px solid slategrey'}}>
                                <ListItemText
                                    sx={classes.listText}
                                    primary={
                                        <Grid
                                            container
                                            spacing={0}
                                            alignItems="top"
                                            style={{width: '100%'}}
                                        >
                                            <Grid item xs={8}>
                                                {`${bal.caseNumber} ${bal.citationNumber ? '(' + bal.citationNumber + ')' : ''}`}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {getDecimal(bal.unpaidAmount)}
                                            </Grid>
                                            <Grid item xs={8}>
                                                {bal.description}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {bal.violationDate}
                                            </Grid>
                                        </Grid>
                                    }
                                    primaryTypographyProps={{
                                        variant: 'body2'
                                    }}
                                />
                            </ListItem>
                        </>
                    );
                })}
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Stack>
                                Total Amount Unpaid: {unpaidTotal}
                            </Stack>
                        }
                        primaryTypographyProps={{
                            variant: 'subtitle2'
                        }}
                    />
                </ListItem>
            </List>
        </>
    );
}

export default LineItems;
